<template>
  <div style="margin-top:20px">
    <div v-if="!loading">
      <div ref="test" class="row" style="margin: 0px">
<!--        <div class="col" style="overflow-y:scroll; max-height: 900px; max-width: 350px; border: 1px solid grey;">-->
<!--          <div style="margin:10px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">-->
<!--            Track Vehicle:&nbsp;<b-checkbox size="lg" v-model="reload_enabled" @change="reload_enabled == !reload_enabled"/>-->
<!--          </div>-->
<!--          <div style="margin:10px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">-->
<!--            Follow Vehicle:&nbsp;<b-checkbox size="lg" v-model="follow_enabled" @change="follow_enabled == !follow_enabled"/>-->
<!--          </div>-->
<!--          <br/>-->
<!--          <div @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 18px;border-top: 1px solid grey; text-align: left; padding:10px">-->
<!--            <span v-if="veh.gps[0].speedMilesPerHour == 0" style="color: darkred; font-size: 18px; font-weight: bold">{{veh.name | trim(30)}}</span>-->
<!--            <span v-else style="color: green; font-size: 18px; font-weight: bold">{{veh.name | trim(25)}} - {{parseInt(markers[0].speed)}} mph</span>-->
<!--            <br/>-->
<!--            <span v-if="veh.driver_name" >-->
<!--              <img src="/driver-icon.png"/> {{veh.driver_name}} ({{veh.driver_phone}})-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 1080px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :key="idx"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{
                              pixelOffset: { width: 0, height: -65 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
    <div style="color: var(--fi-brand); font-family: 'inherit' ;font-size: 24px; padding:20px;">
      powered by &#8594; <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img height="40" src="/initek-logo.png"/></a>
    </div>
  </div>
</template>
<script>
import {get_vehicle_track} from '../networking/apis'

export default {
  name: 'vehicle_map_track',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      tenant_id: null,
      items: [],
      loading: true,
      center: null,
      zoom: null,
      markers: [],
      bounds: null,
      reload_enabled: true,
      reload_interval: 16000,
      reload_center: null,
      follow_enabled: true,
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.tenant_id = this.$route.path.split('/vehicle-track/')[1].split("/")[0]
      this.vehicle_id = this.$route.path.split('/vehicle-track/')[1].split("/")[1]
      this.load_data()
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_vehicle_track(this.tenant_id,'vehicle',this.vehicle_id,6000)
        this.summary = data.summary
        this.items = data.results
        this.zoom = this.summary.zoom

        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            let latest_loc = loc.gps[loc.gps.length - 1]
            const position = {
              lat: Number(latest_loc.latitude),
              lng: Number(latest_loc.longitude),
            };
            if (this.center == null) {
              this.center = position;
              this.reload_center = position;
            }
            let marker_title = loc.name

            if (loc.driver_name != null)
              marker_title += " (" + loc.driver_name + ")"

            this.markers.push({position: position, heading: latest_loc.headingDegrees, title: marker_title, bus_name: loc.name, speed:latest_loc.speedMilesPerHour, label: {text: marker_title, className: 'tracking-label'}, icon: this.arrowSymbol(latest_loc)});
          }
        }

        this.zoom = 15
        this.loading = false
        await this.sleep(this.reload_interval)
        this.reload_data()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    async reload_data() {
      try {
        var startTs = Date.now();

        if (this.$pageVisibility && this.$pageVisibility.hidden)
          return

        if (!this.reload_enabled)
          return

        const {value: {data = []}} = await get_vehicle_track(this.tenant_id, 'vehicle', this.vehicle_id, this.reload_interval)
        this.summary = data.summary
        this.items = data.results
        this.items_full = data.results

        if (this.items && this.items.length > 0) {
          for (const item of this.items) {
            for (const new_loc of item.gps) {
              await this.animated_move(this.markers[0], new_loc, item.gps.length);
              this.check_map_bounds()
            }
          }
        }

        while ((startTs + this.reload_interval) > Date.now()) {
          await this.sleep(1000)
        }

        this.reload_data()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    check_map_bounds() {

      //console.log("check bounds...")
      if (!this.follow_enabled)
        return;

      if (!this.bounds)
        this.bounds = new google.maps.LatLngBounds();

      let position = this.markers[0].position;
      this.bounds.extend(position);

      if (this.$refs.mapRef && !this.$refs.mapRef.$mapObject.getBounds().contains(position)) {
        //console.log("recentering...")
        this.animate_pan(this.$refs.mapRef.$mapObject,position,500,2000);
        this.reload_center = position;
      }
    },
    async animated_move(marker,new_loc,loc_cnt) {

      const new_position = {
        lat: Number(new_loc.latitude),
        lng: Number(new_loc.longitude),
      };

      let new_heading = Number(new_loc.headingDegrees);
      let old_heading = marker.icon.rotation;

      //console.log("heading change: old = " + old_heading + ", new = " + new_heading);

      if (new_heading == 0)
        new_heading = marker.icon.rotation;
      if (old_heading == 0)
        marker.icon.rotation = new_heading;

      marker.speed = new_loc.speedMilesPerHour;

      var delta_incr = 100;

      //marker.icon = this.arrowSymbol(marker.icon.rotation,new_loc.speedMilesPerHour);

      var deltalat = (new_position.lat - marker.position.lat) / delta_incr;
      var deltalng = (new_position.lng - marker.position.lng) / delta_incr;
      var deltaheading = (new_heading - marker.icon.rotation) / delta_incr;

      var direction = 'clockwise';
      if (new_heading > old_heading) {
        if ((new_heading - old_heading) > 180) {
          direction = 'counterclockwise';
          deltaheading = (old_heading + (360-new_heading)) / delta_incr;
        } else {
          deltaheading = (new_heading - old_heading) / delta_incr;
        }
      } else if (old_heading > new_heading) {
        if ((old_heading - new_heading) > 180) {
          deltaheading = (new_heading + (360-old_heading)) / delta_incr;
        } else {
          deltaheading = (old_heading - new_heading) / delta_incr;
          direction = 'counterclockwise';
        }
      }

      if (Math.abs(old_heading - new_heading) < 2)
        deltaheading = 0;

      //console.log("direction: " + direction + ":" + Math.round(deltaheading * delta_incr));

      var delay = (this.reload_interval/delta_incr/loc_cnt);

      //console.log("heading adjust: old = " + old_heading + ", new = " + new_heading + ", deltaheading: " + deltaheading + ",delay: " + delay);

      for (var i = 0; i < delta_incr; i++) {

        let incr_position = {
          lat: (marker.position.lat + deltalat),
          lng: (marker.position.lng + deltalng),
        };
        marker.position = incr_position;

        // if (i % 20 == 0)
        //   console.log("processing incr:" + i);
        //
        // if (marker.position.lng == new_position.lng)
        //   console.log("done processing incr");


        if (deltaheading != 0) {
          if (direction == 'clockwise')
            marker.icon.rotation = Number(marker.icon.rotation + deltaheading);
          else
            marker.icon.rotation = Number(marker.icon.rotation - deltaheading);

          // marker.icon.rotation = marker.icon.rotation + deltaheading;
          //console.log("updated heading: " + marker.icon.rotation)

          if (marker.icon.rotation > 360) {
            //console.log("resetting >360 to 0");
            marker.icon.rotation = 0;
          }

          if (Math.floor(marker.icon.rotation) != (Math.floor(marker.icon.rotation + deltaheading))) {
            //console.log("-->rotating: " + marker.icon.rotation)
            marker.icon =
                {
                  path: (new_loc.speedMilesPerHour == 0 || new_heading == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
                  scale: 1.5,
                  strokeColor: "white",
                  strokeStyle: "bold",
                  fillColor: new_loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
                  fillOpacity: .6,
                  rotation: marker.icon.rotation
                }
          }
        }
        await this.sleep(delay);
      }
      marker.icon.rotation = new_heading;
    },
    animate_pan(map, endPosition, n_intervals, T_msec) {
      var f_timeout, getStep, i, j, lat_array, lat_delta, lat_step, lng_array, lng_delta, lng_step, pan, ref, startPosition;
      getStep = function(delta) {
        return parseFloat(delta) / n_intervals;
      };
      startPosition = map.getCenter();
      lat_delta = endPosition.lat - startPosition.lat();
      lng_delta = endPosition.lng - startPosition.lng();
      lat_step = getStep(lat_delta);
      lng_step = getStep(lng_delta);
      lat_array = [];
      lng_array = [];
      for (i = j = 1, ref = n_intervals; j <= ref; i = j += +1) {
        lat_array.push(map.getCenter().lat() + i * lat_step);
        lng_array.push(map.getCenter().lng() + i * lng_step);
      }
      f_timeout = function(i, i_min, i_max) {
        return parseFloat(T_msec) / n_intervals;
      };
      pan = function(i) {
        if (i < lat_array.length) {
          return setTimeout(function() {
            map.panTo(new google.maps.LatLng({
              lat: lat_array[i],
              lng: lng_array[i]
            }));
            return pan(i + 1);
          }, f_timeout(i, 0, lat_array.length - 1));
        }
      };
      return pan(0);
    },
    arrowSymbol(loc) {
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    filter_items() {
      this.items = this.items_full
      this.markers_new = this.markers_full
      if (this.selected_route_name != '') {
        this.items = this.items.filter(item => item.route_name == this.selected_route_name)
        this.markers_new = this.markers_new.filter(item => item.route_name == this.selected_route_name)
      }
      this.markers = this.markers_new
    },
  },
  computed:{
  },
  watch: {
    selected_route_name(val) {
      this.filter_items()
    }
  }
}
</script>
<style scope>

.tracking-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 30px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
</style>